import { Routes } from '@angular/router';
import { adminGuard } from './core/guards/admin.guard';
import { authGuard } from './core/guards/auth.guard';
import { unsavedChangesGuard } from './core/guards/unsaved-changes.guard';

// `title` is set as the browser-tab title by Angular's TitleStrategy: each page gets its own, so tabs
// and history entries can be told apart (WCAG 2.4.2).
export const ROUTES: Routes = [
  {
    path: 'claim-inquiry',
    loadComponent: () =>
      import('./features/claim-inquiry/pages/claim-inquiry-list/claim-inquiry-list.page')
        .then((m) => m.ClaimInquiryListPageComponent),
    canActivate: [authGuard],
    title: 'Zaprosila – MOST',
  },
  {
    path: 'claim-inquiry-recipient/details/:id',
    loadComponent: () =>
      import('./features/claim-inquiry/pages/claim-inquiry-recipient-details/claim-inquiry-recipient-details.page')
        .then((m) => m.ClaimInquiryRecipientDetailsPageComponent),
    canActivate: [authGuard],
    title: 'Obravnava zaprosila – MOST',
  },
  {
    path: 'claim-inquiry-recipient/:id/upsert',
    loadComponent: () =>
      import('./features/claim-inquiry/pages/claim-inquiry-recipient-upsert/claim-inquiry-recipient-upsert.page')
        .then((m) => m.ClaimInquiryRecipientUpsertPageComponent),
    canActivate: [authGuard],
    canDeactivate: [unsavedChangesGuard],
    title: 'Odgovor na zaprosilo – MOST',
  },
  {
    path: 'claim-inquiry/details/:id',
    loadComponent: () =>
      import('./features/claim-inquiry/pages/claim-inquiry-details/claim-inquiry-details.page')
        .then((m) => m.ClaimInquiryDetailsPageComponent),
    canActivate: [authGuard],
    title: 'Podrobnosti zaprosila – MOST',
  },
  {
    path: 'claim-inquiry/new',
    loadComponent: () =>
      import('./features/claim-inquiry/pages/claim-inquiry-upsert/claim-inquiry-upsert.page')
        .then((m) => m.ClaimInquiryUpsertPageComponent),
    canActivate: [authGuard],
    canDeactivate: [unsavedChangesGuard],
    title: 'Novo zaprosilo – MOST',
  },
  {
    path: 'claim-inquiry/edit/:id',
    loadComponent: () =>
      import('./features/claim-inquiry/pages/claim-inquiry-upsert/claim-inquiry-upsert.page')
        .then((m) => m.ClaimInquiryUpsertPageComponent),
    canActivate: [authGuard],
    canDeactivate: [unsavedChangesGuard],
    title: 'Urejanje zaprosila – MOST',
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('./features/settings/pages/settings/settings.page')
        .then((m) => m.SettingsPageComponent),
    canActivate: [authGuard],
    title: 'Nastavitve – MOST',
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./features/admin/pages/admin/admin.page')
        .then((m) => m.AdminPageComponent),
    canActivate: [authGuard, adminGuard],
    title: 'Administracija – MOST',
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./features/error/error.page').then((m) => m.ErrorPageComponent),
    title: 'Napaka – MOST',
  },
  {
    // Where a refused login lands; anonymous, because the user has no portal session.
    path: 'dostop-zavrnjen',
    loadComponent: () =>
      import('./features/access-denied/access-denied.page').then((m) => m.AccessDeniedPageComponent),
    title: 'Dostop zavrnjen – MOST',
  },
  {
    path: '',
    redirectTo: 'claim-inquiry',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'claim-inquiry',
  },
];
